import React, { useState } from "react";
import DynamicModal from "../Common/DynamicModal";
import { MyCardDirectiveModalProps } from "../../types/components";
import { ACTION_DISPLAY_TYPES, CARD_DIRECTIVE_TYPES, RR_TRANSFER_METHODS, RR_RSP } from "../../constants/enums";
import { useHistory } from "react-router-dom";
import { ROUTES as PAGE_ROUTES } from "../../constants/clientRoutes";
import { useDispatch } from "react-redux";
import { SetIsInAppCard } from "../../actions/card";
import useErrorModal from "../../hooks/useErrorModal";
import useGetRRAuthData from "../../hooks/useGetRRAuthData";

import Action from "../Common/Action";
import SpinningLoader from "../Common/SpinningLoader";
import { trackEvent } from "../../services/eventTracker";
import { EVENTS } from "../../constants/events";

const MyCardDirectiveModal = ({ open, setOpen, modalData }: MyCardDirectiveModalProps) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const openErrorModal = useErrorModal();
  const [loading, setLoading] = useState(false);
  const getRRAuthData = useGetRRAuthData({ setLoading, openErrorModal });

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>, directiveType: string) => {
    e.stopPropagation();

    switch (directiveType) {
      case CARD_DIRECTIVE_TYPES.SUPPORT:
        history.push(PAGE_ROUTES.SUPPORT_INDEX);
        break;
      case CARD_DIRECTIVE_TYPES.CLOSE_MODAL:
        setOpen(false);
        break;
      case CARD_DIRECTIVE_TYPES.MYCARD_ACTIVATE_CARD_PHYSICAL:
        history.push(PAGE_ROUTES.MY_CARD.ACTIVATE_REPLACEMENT_CARD);
        break;
      case CARD_DIRECTIVE_TYPES.MYCARD_ACTIVATE_CARD_INAPP:
        history.push(PAGE_ROUTES.MY_CARD.ACTIVATE_IN_APP_CARD);
        dispatch(SetIsInAppCard(true));
        break;
      case CARD_DIRECTIVE_TYPES.MOBILE_WALLET_CONTINUE:
        getRRAuthData(RR_RSP.MASTERCARD, RR_TRANSFER_METHODS.MOBILE_WALLET);
        break;
      case CARD_DIRECTIVE_TYPES.PUSH_TO_CARD_CONTINUE:
        trackEvent(EVENTS.READY_REMIT.PUSH_TO_CARD.SDK_REMINDER_CONTINUE);
        getRRAuthData(RR_RSP.VISA, RR_TRANSFER_METHODS.PUSH_TO_CARD);
        break;
      case CARD_DIRECTIVE_TYPES.PUSH_TO_CARD_CLOSE_MODAL:
        trackEvent(EVENTS.READY_REMIT.PUSH_TO_CARD.SDK_REMINDER_BACK);
        setOpen(false);
        break;
    }
  }

  return (
    <>
      <DynamicModal
        open={open}
        setClose={setOpen}
        showCloseIcon={true}
        header={<h4 className="modal-title">{modalData?.title}</h4>}
        body={
          <div>
            <p className="marengo-grey mb-16">{modalData?.body}</p>
            <div className="flex-row justify-content-end align-items-center v2">

              {modalData?.secondaryAction && (
                <Action
                  title={modalData?.secondaryAction?.text}
                  displayType={ACTION_DISPLAY_TYPES.TEXT}
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleClick(e, modalData.secondaryAction!.directiveType)}
                  className="spacing-right-tiny"
                  width="short"
                />
              )}

              {modalData?.primaryAction && (
                <Action
                  title={modalData?.primaryAction!.text}
                  displayType={ACTION_DISPLAY_TYPES.PRIMARY}
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleClick(e, modalData.primaryAction!.directiveType)}
                  width="narrow"
                />
              )}

            </div>
          </div>
        }
        className="my-card-directive-modal min-w-300 max-w-400 v3"
      />

      <SpinningLoader show={loading} />
    </>

  );
}

export default MyCardDirectiveModal;